export default {"src":"https://cdn.jetlend.ru/_next/static/media/sk.e72e1d60.svg","height":40,"width":136,"blurWidth":0,"blurHeight":0};